import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Base routes
const Status404 = Loader(
  lazy(() => import('src/content/commons/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/commons/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/commons/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/commons/Status/Maintenance'))
);

const baseRoutes = [
  {
    path: '/',
    element: <Navigate to={'/account/login'} />
  },
  {
    path: 'overview',
    element: <Navigate to="/" replace />
  },
  {
    path: '*',
    element: <Status404 />
  },
  {
    path: 'status',
    children: [
      {
        path: '500',
        element: <Status500 />
      },
      {
        path: 'maintenance',
        element: <StatusMaintenance />
      },
      {
        path: 'coming-soon',
        element: <StatusComingSoon />
      }
    ]
  },
  {
    path: '*',
    element: <Status404 />
  }
];

export default baseRoutes;
